import React from 'react';
import { browserHistory,hashHistory, Link } from 'react-router';
import { connect } from 'react-redux'
import '../login.css';
import Paper from 'material-ui/Paper';
import { resourceApi } from '../utils/fetchUtil';
import Alert from 'material-ui/svg-icons/action/report-problem';
import ThumbsUp from 'material-ui/svg-icons/action/thumb-up';
import {Card, CardHeader,} from 'material-ui/Card';
import ProviderList from '../Components/ProviderListMini';
import ProviderCard from '../Components/ProviderCard';
import HeaderSmall from '../Components/Header/HeaderSmall';
import {logProviderView} from '../actions/logActions'
import Divider from 'material-ui/Divider';
import { createNewMessage } from '../actions/messageActions';
import CareGuideContact from '../Components/CareGuideContact';
import TabStrip  from '../Components/TabStrip';

const checkmarkstyle = {
    height:40,
    width:40,
    float: 'left'
}

const alertstyle = {
    height:40,
    width:40,
    color: '#EF5350',
    marginTop:30
}



class ProviderPage extends React.Component {

     constructor(props) {
        super(props);

        this.state = {  
            facility: {},
            providers: [],
            provider: {},
            view: 'list',
            fetching: false
        };

        
        this.flipViews = this.flipViews.bind(this);
        this.selectProvider = this.selectProvider.bind(this);
        
    }
    
    flipViews(){

      if(this.state.view === 'list') {
        browserHistory.goBack();
      }
      else{
        this.setState({ view: 'list'});
      }
    }

    careGuideFirstName(name) {
        if(name) {
            return name.split(' ')[0];
        }

        else{
            return "Care Guides";
        }
    }

    selectProvider = (providerId) => {
        //, cost
        //hashHistory.push(`provider/${providerId}/view/${cost}/false`); 
        hashHistory.push(`/shop/confirm/${this.state.provider.ProviderID}/${providerId}/${this.props.params.cost}`);
    }

    renderActionLabel = () =>{

        if(this.props.member.IsCareGuideActive){
            return <p style={{color: '#EF5350' }}>To take advantage of this ${this.props.params.cost} price, you must contact a Care Guide to have your procedure authorized.</p>
        }
        else{
            return <p style={{color: '#EF5350' }}>To confirm your procedure is free, contact customer care below.</p>
        }
    }
   

    render() {

        return (
            <div>
                <HeaderSmall title="Details" />  
                 {/*goBackFunction={this.flipViews}*/}

                {(!this.state.fetching) && (
                    <div>
                          <br />
                        <div className="provider-card">
                            <ProviderCard providerId={this.props.params.id} selectProvider={this.selectProvider} cost={this.props.params.cost} sctp={this.props.params.sctp}  />
                        </div>
                        
                        {(this.props.params.isDx === 'true') && (
                            <div className="container">
                                <br />
                                <Card>
                                    <CardHeader
                                        textStyle={{width:'80%', paddingRight:0, paddingTop:0}}
                                        avatar={<Alert style={alertstyle} />}
                                        title={this.renderActionLabel()}
                                        />
                                    <Divider />
                                    <CareGuideContact />
                                </Card>
                            </div>
                        )}
                
                        {(this.state.provider.IsFacility) && (this.props.params.docandfacility === 'true') && (this.props.params.isDx === 'false') && (
                            <div>
                                <div className="container">
                                    <Card>
                                        <CardHeader
                                            textStyle={{ paddingTop:0, width: '72%'}}
                                            avatar={<ThumbsUp style={checkmarkstyle} className="primary1Color" />}
                                            title={
                                                <span style={{fontSize:12}}>
                                                   To receive care, you must choose two things: 
                                                   <ul><li>a place to receive care (a hospital or clinic)</li><li> a doctor to perform your care.</li></ul>
                                                </span>
                                            }
                                        />
                                    </Card>
                                     <Paper zDepth={1} >
                                        <ProviderList providers={this.state.providers} selectProvider={this.selectProvider} />
                                    </Paper>
                                </div>
                            </div>
                        )}
                    </div>
                )}
                <br />
                <br />
                <br />
                <br />
                <TabStrip activeTab={2} />
            </div>
        );
  }
}


const mapDispatchToProps = (dispatch) => {
  return {
    handleShoppableCptSelect: (rowIndex) => {
      
    },
    logProviderView: (providerId, sctp) => {
      dispatch(logProviderView(providerId, sctp));
    },
    clearMessage: () => {
        dispatch(createNewMessage())
    }
  }
}

const mapStateToProps = (state) => ({
    searchResults: state.thisApp.searchResults,
    cost: state.thisApp.searchResults.cost,
    member: state.thisApp.auth.member
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProviderPage)

/*
<IconButton
                            iconStyle={styles.largeIcon}
                            style={styles.large}
                            >
                            <BackIcon onClick={() => this.setState({view: 'list'})} />
                            </IconButton>*/


// WEBPACK FOOTER //
// ./src/Pages/Provider.js